export const calculateDeckPriceData = (deckCards, priceSource = null, printMapping = null, scope = null) => {
	const allCount = {}
	const missingCount = {}
	const havesCount = {}
	const dataAll = {}
	const dataMissing = {}
	const dataHaves = {}
	let priceAllTotal = 0
	let priceMissingTotal = 0
	let priceHavesTotal = 0

	deckCards.forEach((deckCard) => {
		// all
		if (!(deckCard.card.slug in allCount)) {
			allCount[deckCard.card.slug] = 1
			dataAll[deckCard.card.slug] = {
				...deckCard,
				ids: [deckCard.id]
			}
		} else {
			allCount[deckCard.card.slug] += 1

			const existing = dataAll[deckCard.card.slug]

			dataAll[deckCard.card.slug] = {
				...existing,
				ids: [
					...existing.ids,
					deckCard.id
				]
			}
		}

		priceAllTotal += getDeckCardPrice(deckCard, priceSource, printMapping)

		// missing / haves
		if (deckCard.ownsCard) {
			if (!(deckCard.card.slug in havesCount)) {
				havesCount[deckCard.card.slug] = 1
				dataHaves[deckCard.card.slug] = deckCard
			} else {
				havesCount[deckCard.card.slug] += 1
			}

			priceHavesTotal += getDeckCardPrice(deckCard, priceSource, printMapping)
		} else {
			if (!(deckCard.card.slug in missingCount)) {
				missingCount[deckCard.card.slug] = 1
				dataMissing[deckCard.card.slug] = deckCard
			} else {
				missingCount[deckCard.card.slug] += 1
			}

			priceMissingTotal += getDeckCardPrice(deckCard, priceSource, printMapping)
		}
	})

	const allCards = Object.keys(allCount).map(slug => ({
		...dataAll[slug],
		quantity: allCount[slug],
		percent: allCount[slug] * dataAll[slug].price / priceMissingTotal * 100
	}))

	const mostExpensiveCards = [...allCards].sort((a, b) => b.percent - a.percent).slice(0, 5)
	const mostExpensiveCardsPercentSum = Math.round(mostExpensiveCards.reduce((a, b) => a + b.percent, 0))

	const missingTotal = deckCards.filter(item => !item.ownsCard).length
	const havesTotal = deckCards.filter(item => item.ownsCard).length

	const missingCards = Object.keys(missingCount).map(slug => ({
		...dataMissing[slug],
		quantity: missingCount[slug],
		percent: missingCount[slug] * dataMissing[slug].price / priceMissingTotal * 100
	}))

	const havesCards = Object.keys(havesCount).map(slug => ({
		...dataHaves[slug],
		quantity: havesCount[slug]
	}))

	// scope
	let priceTotal = priceAllTotal

	if (scope === 'missing') {
		priceTotal = priceMissingTotal
	} else if (scope === 'haves') {
		priceTotal = priceHavesTotal
	}

	return {
		priceTotal,
		cards: allCards,
		missingTotal,
		havesTotal,
		mostExpensiveCards,
		mostExpensiveCardsPercentSum,
	}
}

const getDeckCardPrice = (deckCard, priceSource, printMapping) => {
	if (printMapping) {
		const print = printMapping[deckCard.id]

		if (print && print.includePrice) {
			return print.prices ? print.prices[priceSource] : 0
		}
	} else if (deckCard.price) {
		return deckCard.price
	}

	return 0
}
